<template>
  <div>
    <table class="table table-sm m-0 border">
      <tbody>
      <template v-for="t in tasks" v-if="t.status === 3">
        <tr>
          <td class="pr-3"
              :rowspan="t.task_data.conditions.filter((v) => +v.value && v.alias !== 'interval').length + 1">
            {{ t.type_id === 28 ? 'UTEKA' : '003sm' }}
          </td>
          <td class="zero_height" colspan="6"></td>
<!--          <td :rowspan="t.task_data.conditions.filter((v) => +v.value && v.alias !== 'interval').length + 1">-->
<!--            <button v-if="isTaskIsPass(t)" @click="openTimeShiftModal(t)" type="button"-->
<!--                    class="btn btn-default">-->
<!--              <i class="icon-fa icon-fa-clock-o"/>-->
<!--            </button>-->
<!--          </td>-->
        </tr>
        <tr v-for="(c, i) in t.task_data.conditions" v-if="+c.value && c.alias !== 'interval'"
            :class="{'active': isConditionPass(c, t)}">
          <td>{{ c.joinCondition === 'and' ? 'и' : 'или' }}</td>
          <td>{{ c.title }}</td>
          <td>{{ c.condition === 'more' ? '>' : '<' }}</td>
          <td>{{ c.value }}</td>
          <td>
            <template v-if="t.task_data.record">
              <v-popover :auto-hide="true">
                <button class="btn btn-default">
                  <i class="icon-fa icon-fa-info icon-info"/>
                </button>
                <!--                <button @click="getDrugInfo(drug.id, true)" style="height: 38px"-->
                <!--                        class="btn btn-info btn-xs border-r-0 sm-btn"><i class="icon-fa icon-fa-info icon-info"></i>-->
                <!--                </button>-->
                <template slot="popover">
                  <template v-if="t.type_id === 30">
                    <SM003Statistics :stat="t.task_data.record"/>
                  </template>
                  <template v-if="t.type_id === 28">
                    <p>UTEKA <a :href="t.task_data.record.source_url"
                                target="_blank"><i
                      class="icon-fa icon-fa-globe"/></a></p>
                    <UtekaStatistics :stats="t.task_data.record"/>
                  </template>
                </template>
              </v-popover>
            </template>
          </td>
          <!--                    <td>парсер</td>-->
          <!--          <td>{{ getValueByCondition(c, t) }}</td>-->
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>

import api from "@/api";
import {customUpdateData} from "@/eventsBus";
import UtekaStatistics from "@/components/suppliers/UtekaStatistics.vue";
import SM003Statistics from "@/components/suppliers/SM003Statistics.vue";

export default {
  components: {SM003Statistics, UtekaStatistics},
  props: ['tasks', 'activeRecord'],
  methods: {
    isConditionPass(cond, task) {
      // console.log(cond, task);
      const val = +this.getValueByCondition(cond, task);
      // console.log(val);
      if (cond.condition === 'less') {
        return val < +cond.value
      } else {
        return val > +cond.value
      }
    },
    isTaskIsPass(task) {
      const join = task.task_data.conditions[0]?.joinCondition;
      const pass = [];
      task.task_data.conditions.forEach((c) => {
        if (!c.value || c.alias === 'interval') return;
        if (c.condition === 'less') {
          pass.push(+this.getValueByCondition(c, task) < +c.value);
        } else {
          pass.push(+this.getValueByCondition(c, task) > +c.value);
        }
      });
      if (join === 'and') return !pass.includes(false);
      return pass.includes(true);
    },
    openTimeShiftModal(task) {
      this.$store.dispatch("platform/setGlobalModalData", {
        type: 'ShiftTaskActualDate',
        headerText: 'Сменить дату актуальности записи',
        record: task,
        callBack: this.updateTaskStatus
      });
    },
    async updateTaskStatus(record, saveData) {
      if (!saveData.date) {
        toastr['warning']('не указана дата', 'Ошибка');
        return false;
      }
      const {data} = await api.post('/tasks/' + record.id, {
        action: 'shiftActualDate',
        data: {...saveData, returnStatus: record.status}
      })
      if (data.success) {
        customUpdateData.$emit('updateList');
        toastr['success']('Сохранено', 'Успешно');
      } else {
        toastr['warning'](data.message ?? 'ошибка сервера', 'Ошибка');
        return false;
      }
      return true;
    },
    getValueByCondition(condition, task) {
      const record = task.task_data.record;
      if (task.type_id === 28) {
        if (condition.alias === 'price') {
          // console.log(condition.target, task.drug?.suppliers_price?.extra_data?.min_price);
          let value = 0;
          if (condition.target === 'low') {
            value = +(record?.extra_data?.min_price ?? 0);
            if (!value) value = +(record?.price ?? 0);
          } else {
            value = +(record?.price ?? 0);
            if (!value) value = +(record?.extra_data?.min_price ?? 0);
          }
          // console.log(condition.target, value, task.drug?.suppliers_price?.extra_data?.min_price ?? 0, task.drug?.suppliers_price?.price ?? 0);
          return value;
          // return condition.target === 'low' ? task.drug?.suppliers_price?.extra_data?.min_price ??
          //   task.drug?.suppliers_price?.price ?? 0 : task.drug?.suppliers_price?.price ?? task.drug?.suppliers_price?.extra_data?.min_price ?? 0;
        }
        if (condition.alias === 'store') {
          return record?.extra_data?.in_stores ?? 0;
        }
      }
      if (condition.alias === 'store') return record?.stores ?? 0;
      return record[condition.alias] ?? 0;
    }
  }
}

</script>

<style scoped>
table.table td {
  padding: 5px;
}

.zero_height {
  height: 0;
  padding: 0 !important;
  border: 0;
}

table.table tr.active {
  background-color: #01fc012e;
}
</style>
